<template>
<div id="app" :key="key">
    <transition :key="key">
        <router-view></router-view>
    </transition>
</div>
</template>

<script>
/*import Vue from 'vue'
	Vue.use(vant);*/

export default {
    name: "app",
    computed: {
        key() {
            return this.$route.name !== undefined ?
                this.$route.name + new Date() :
                this.$route + new Date();
        },
    },
    mounted() {
       // var ua = window.navigator.userAgent.toLowerCase();
        // let isWeiXin = false
        // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //     isWeiXin = true;
        // } else {
        //     isWeiXin = false;
        // }
        // const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // if (isWeiXin && isiOS) {
        //     window.wxInited = false
        //     document.addEventListener('WeixinJSBridgeReady', () => {
        //         setTimeout(() => {
        //             const domList = document.getElementById('container').childNodes[0].childNodes
        //             let video = ""
        //             console.log(domList)
        //             for (let i in domList) {
                        
        //                 if (domList[i].nodeName == "VIDEO") {
        //                     console.log(domList[i].nodeName)
        //                     video = domList[i]
        //                     domList[i].play();
        //                     video.play();
        //                     console.log(domList[i])
        //                 }
        //             }
        //         }, 2000)

        //     }, false)
        // }
        // 禁止页面缩放
        window.onload = function () {
            document.addEventListener("touchstart", function (event) {
                if (event.touches.length > 1) {
                    event.preventDefault();
                }
            });
            document.addEventListener("gesturestart", function (event) {
                event.preventDefault();
            });
        };
        //PC与H5页面跳转
        let router = this.$route
        if (/Android|HarmonyOSWebView|Harmony|webOS|ios|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
            return
        } else {
            switch (router.name) {
                case 'live':
                    window.location.href = 'https://auction.artron.net/live'
                    break
                case 'live/detail':
                    window.location.href = 'https://auction.artron.net/live/detail?id=' + router.query.id + '&special_id=' + router.query.special_id
                    break
                case 'live/auction':
                    window.location.href = 'https://auction.artron.net/live/auction/' + router.params.liveid + '/' + router.params.art_id + '/' + router.params.special_id
                    break
            }
        }
    }
};
</script>

<style>
@import "./assets/css/index.css"
/* #app {

font-family: 'Avenir', Helvetica, Arial, sans-serif;

-webkit-font-smoothing: antialiased;

-moz-osx-font-smoothing: grayscale;

text-align: center;

color: #2c3e50;

height:100%;
	}
	body,html{

font-size:12px;

height:100%;
	}
	* {

padding: 0;

margin: 0;

max-width:100%;
	}
	input {

border: none;

outline: none;

-webkit-appearance: none;
	}
	ul,
	ol {

list-style: none;
	}
	.f_left {

float: left;
	}

.f_right {

float: right;
	}
	.clearfix::before,
	.clearfix::after {

content: "";

height: 0;

line-height: 0;

display: block;

visibility: hidden;

clear: both;
	} */
</style>
